import { EJobPostingStatus, EJobPostingType } from '@configs'
import { t } from 'i18next'
import moment from 'moment'
import { z } from 'zod'

export const jobPostSchema = z.object({
  title: z
    .string()
    .trim()
    .nonempty({
      message: t('error:field_required') as string,
    })
    .max(100, {
      message: t('error:max_length_100') as string,
    }),
  titleInDutch: z
    .string()
    .trim()
    .nonempty({
      message: t('error:field_required') as string,
    })
    .max(100, {
      message: t('error:max_length_100') as string,
    }),
  address: z
    .string()
    .trim()
    .nonempty({
      message: t('error:field_required') as string,
    })
    .max(255, {
      message: t('error:max_length_255') as string,
    }),
  description: z
    .string()
    .trim()
    .nonempty({
      message: t('error:field_required') as string,
    })
    .max(2200, {
      message: t('error:max_length_2200') as string,
    }),
  descriptionInDutch: z
    .string()
    .trim()
    .nonempty({
      message: t('error:field_required') as string,
    })
    .max(2200, {
      message: t('error:max_length_2200') as string,
    }),
  keyResponsibilities: z
    .string()
    .trim()
    .nonempty({
      message: t('error:field_required') as string,
    })
    .max(2200, {
      message: t('error:max_length_2200') as string,
    }),
  keyResponsibilitiesInDutch: z
    .string()
    .trim()
    .nonempty({
      message: t('error:field_required') as string,
    })
    .max(2200, {
      message: t('error:max_length_2200') as string,
    }),
  requirements: z
    .string()
    .trim()
    .nonempty({
      message: t('error:field_required') as string,
    })
    .max(2200, {
      message: t('error:max_length_2200') as string,
    }),
  requirementsInDutch: z
    .string()
    .trim()
    .nonempty({
      message: t('error:field_required') as string,
    })
    .max(2200, {
      message: t('error:max_length_2200') as string,
    }),
  whatWeOffer: z
    .string()
    .trim()
    .nonempty({
      message: t('error:field_required') as string,
    })
    .max(2200, {
      message: t('error:max_length_2200') as string,
    }),
  whatWeOfferInDutch: z
    .string()
    .trim()
    .nonempty({
      message: t('error:field_required') as string,
    })
    .max(2200, {
      message: t('error:max_length_2200') as string,
    }),
  dateExpired: z
    .string()
    .trim()
    .nonempty({
      message: t('error:field_required') as string,
    }),
  type: z
    .string()
    .trim()
    .nonempty({
      message: t('error:field_required') as string,
    }),

  status: z.number(),
})

export type IJobSchema = z.infer<typeof jobPostSchema>

export const defaultValues: IJobSchema = {
  title: '',
  titleInDutch: '',
  address: '',
  description: '',
  descriptionInDutch: '',
  keyResponsibilities: '',
  keyResponsibilitiesInDutch: '',
  requirements: '',
  requirementsInDutch: '',
  whatWeOffer: '',
  whatWeOfferInDutch: '',
  dateExpired: moment().format('YYYY-MM-DD'),
  type: EJobPostingType.HYBRID_FULL_TIME,
  status: EJobPostingStatus.EXPIRED,
}
